
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  Ng2TableDefault,
  DiaFestivo,
  DiaEspecial,
  BaseControl,
  ConfirmComponent,
  ModalTableComponent,
  Const
} from '@app/shared/index';
import { SpecialDaysFormService } from './shared/special-days-form.service';
import { SpecialDaysDataService } from './shared/special-days-data.service';
import { ToastrService } from 'ngx-toastr';
import {
  GlobalInfoService,
  AuthenticationService
} from '@app/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-special-days',
  templateUrl: './special-days.component.html',
  styleUrls: ['./special-days.component.scss'],
  providers: [SpecialDaysFormService, SpecialDaysDataService]
})
export class SpecialDaysComponent extends Ng2TableDefault implements OnInit, OnDestroy {
  // define la pregunta del componente de confirmacion
  question = '';
  // define la pregunta del modal de la tabla
  questionTable = '';
  // define la posicion del tab
  tab = 'holidays';
  // define la clase del boton de los formularios
  claseButton = '';
  // define el texto de el boton submit de los formularios
  textoButton = '';
  // define cuando se habre el formulario o cierra el formulario
  form = false;
  // define la accion a realizar en el formulario
  modificar = false;
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    review: false,
    update: false,
    delete: false,
  };
  // Contiene los botones que apareceran en la modal de la tabla
  buttons: any = [];
  // controles dinamicos de el formulario
  controls: BaseControl<any>[] = [];
  // contiene la data retornada por los formularios
  formData: any;
  // contiene el registro seleccionado de la tabla
  registroSeleccionado: any[];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirmAction') private confirmAction: ConfirmComponent;
  // Referencia al componente de el modal de acciones de la tabla
  @ViewChild('modalTable') private modalTable: ModalTableComponent;

  constructor(
    private sdfs: SpecialDaysFormService,
    private sdds: SpecialDaysDataService,
    private toastr: ToastrService,
    private gis: GlobalInfoService,
    private as: AuthenticationService,
  ) {
    super();
  }

  init() {
    super.init();
  }

  ngOnInit() {
    // se setea el titulo de la vista actual
    this.gis.set({ title: 'Gestión de días especiales' });
    // determina los permisos del usuario en sesion
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administrationHoliDays,
      Const.types_action_permissions.created,
    );
    this.activateAction.review = this.as.confirmPermission(
      Const.types_permissions.administrationHoliDays,
      Const.types_action_permissions.review,
    );
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administrationHoliDays,
      Const.types_action_permissions.update,
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administrationHoliDays,
      Const.types_action_permissions.delete,
    );
    this.changeTab();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }
  /**
   * Esta funcion hace el cambio de tab, genera la tabla
   * y consulta los registros de las tablas dependiendo de el tab
   *
   * @param {string} [accion='holidays']
   * @memberof SpecialDaysComponent
   */
  changeTab(accion: string = 'holidays') {
    this.tab = accion;
    this.form = false;
    switch (accion) {
      case 'special-days':
        this.columns = [
          {
            title: 'Fecha',
            name: `fecha`,
            className: ['pointer'],
            filtering: {
              filterString: '',
              placeholder: 'Fecha.'
            }
          },
          {
            title: 'Motivo',
            name: 'nombre',
            sort: false,
            filtering: { filterString: '', placeholder: 'Motivo.' }
          },
          {
            title: 'Laboral',
            name: 'tipoL',
            className: ['pointer'],
            filtering: { filterString: '', placeholder: 'Tipo.' }
          }
        ];
        this.controls = this.sdfs.getFieldsSpecialDays();
        if (this.activateAction.review) {
          this.sdds
            .getSpecialDays()
            .subscribe(data => {
              this.data = data;
              this.onChangeTable(this.config);
            });
        } else {
          this.toastr.error(
            'Usted no cuenta con permisos para ver los registros en este módulo',
            'Permiso denegado'
          );
        }
        break;
      default:
        this.columns = [
          {
            title: 'Fecha',
            name: `fecha`,
            className: ['pointer'],
            filtering: {
              filterString: '',
              placeholder: 'Fecha.'
            }
          },
          {
            title: 'Motivo',
            name: 'nombre',
            sort: false,
            filtering: { filterString: '', placeholder: 'Motivo.' }
          }
        ];
        this.controls = this.sdfs.getFieldsHolidays();
        if (this.activateAction.review) {
          this.sdds
            .getHolidays()
            .subscribe(data => {
              this.data = data;
              this.onChangeTable(this.config);
            });
        } else {
          this.toastr.error(
            'Usted no cuenta con permisos para ver los registros en este módulo',
            'Permiso denegado'
          );
        }
        break;
    }
    this.config.className = ['table-striped table-bordered table-hover'];
  }
  /**
   * crea los formularios dinamicos dependiendo en el tab que se encuentra
   * ademas de setear los controles con la data que se envie si es una accion de modificar
   *
   * @param {*} [formData]
   * @memberof SpecialDaysComponent
   */
  dynamicForm(formData?: any) {
    this.form = true;
    let objectModel: any;
    if (this.modificar) {
      objectModel = this.registroSeleccionado;
      this.claseButton = 'btn-warning';
      this.textoButton = 'Modificar';
    } else {
      this.claseButton = 'btn-success';
      this.textoButton = 'Agregar';
    }
    switch (this.tab) {
      case 'special-days':
        if (formData) {
          objectModel = {
            fecha: formData.dtfecha.toLocaleDateString(),
            nombre: formData.txtMotivo,
            tipo: formData.cboTipoDia
          };
        }
        this.controls = this.sdfs.getFieldsSpecialDays(objectModel);
        break;
      case 'holidays':
        if (formData) {
          objectModel = {
            fecha: formData.dtfecha.toLocaleDateString(),
            nombre: formData.txtMotivo
          };
        }
        this.controls = this.sdfs.getFieldsHolidays(objectModel);
        break;
    }
  }
  /**
   * Funcion de click a un registro de las tablas
   *
   * @param {*} data
   * @returns {*}
   * @memberof SpecialDaysComponent
   */
  onCellClick(data: any): any {
    this.registroSeleccionado = data.row;
    if (this.activateAction.update && this.activateAction.delete) {
      this.buttons = [
        { label: 'Modificar', class: 'btn-warning', value: 'modificar' },
        { label: 'Eliminar', class: 'btn-danger', value: 'eliminar' },
        { label: 'Cancelar', value: 'cancelar' }
      ];
      this.openModalTable();
    } else if (this.activateAction.update) {
      this.buttons = [
        { label: 'Modificar', class: 'btn-warning', value: 'modificar' },
        { label: 'Cancelar', value: 'cancelar' }
      ];
      this.openModalTable();
    } else if (this.activateAction.delete) {
      this.buttons = [
        { label: 'Eliminar', class: 'btn-danger', value: 'eliminar' },
        { label: 'Cancelar', value: 'cancelar' }
      ];
      this.openModalTable();
    } else {
      this.toastr.error(
        'Usted no cuenta con permisos para realizar acciones como modificar o eliminar registros en este módulo',
        'Permiso denegado'
      );
    }
  }
  /**
   * cierra el formulario y abre la tabla dependiendo de la pestaña en que se encuentre
   * dependiendo de la accion a realizar carga de nuevo los registros de la tabla o no
   *
   * @param {boolean} [reloading=false]
   * @memberof SpecialDaysComponent
   */
  closeForm(reloading: boolean = false) {
    this.form = false;
    this.modificar = false;
    this.registroSeleccionado = null;
    if (reloading) {
      this.changeTab(this.tab);
    }
  }

  /**
   * Define la accion a realizar dependiendo de la opcion seleccionada en el modal de confirmacion
   *
   * @param {boolean} res
   * @memberof SpecialDaysComponent
   */
  action(res: boolean) {
    if (res) {
      if (this.formData) {
        this.sended(this.formData);
      } else {
        this.delete();
      }
    }
  }

  /**
   * define la accion a realizar despues de seleccionar una opcion en el modal de la tabla
   *
   * @param {String} res
   * @memberof SpecialDaysComponent
   */
  modalTableAction(res: String) {
    switch (res) {
      case 'modificar':
        this.modificar = true;
        this.dynamicForm();
        break;
      case 'eliminar':
        setTimeout(() => {
          this.confirm();
        }, 500);
        break;
    }
  }
  /**
   * Genera el mensaje a mostrar del modal de confirmacion
   * abre el modal de confirmacion
   *
   * @param {*} [data=null]
   * @memberof SpecialDaysComponent
   */
  confirm(data: any = null) {
    if (data) {
      this.formData = data;
      if (this.modificar) {
        this.question = '¿Realmente desea actualizar el registro?';
      } else {
        this.question = '¿Realmente desea agregar el registro?';
      }
    } else {
      this.formData = null;
      this.question = '¿Realmente desea eliminar el registro?';
    }
    this.confirmAction.open();
  }
  /**
   * genera el mensaje a mostrar en modal de acciones de la tabla y abre el modal
   *
   * @private
   * @memberof SpecialDaysComponent
   */
  private openModalTable() {
    switch (this.tab) {
      case 'holidays':
        this.questionTable =
          'Usted ha seleccionado el dia festivo: ' +
          this.registroSeleccionado['nombre'] +
          ' de la fecha: ' +
          this.registroSeleccionado['fecha'];
        break;
      case 'special-days':
        this.questionTable =
          'Usted ha seleccionado la el dia especial: ' +
          this.registroSeleccionado['nombre'] +
          ' de la fecha: ' +
          this.registroSeleccionado['fecha'];
        break;
    }
    this.questionTable += ' ¿Que accion desea realizar?';
    this.modalTable.openModal();
  }

  /**
   * carga los modelos con la informacion agregada en el formulario
   * ejecuta la funcion correspondiente dependiendo de la accion a realizar
   *
   * @private
   * @param {*} data
   * @memberof SpecialDaysComponent
   */
  private sended(data: any) {
    switch (this.tab) {
      case 'holidays':
        const dFestivo: DiaFestivo = new DiaFestivo();
        const fechaFestivo: string[] = data.dtfecha.toLocaleDateString().split('/');
        dFestivo.fecha = fechaFestivo[2] + '-' + fechaFestivo[1] + '-' + fechaFestivo[0];
        dFestivo.nombre = data.txtMotivo;
        if (this.modificar) {
          dFestivo.id = this.registroSeleccionado['id'];
          this.sdds.updateHolidays(dFestivo).subscribe(res => {
            if (res) {
              this.closeForm(true);
            }
          });
        } else {
          this.sdds.addHolidays(dFestivo).subscribe(res => {
            if (res) {
              this.closeForm(true);
            } else {
              console.error('Error');
            }
          });
        }

        break;
      case 'special-days':
        const dEspecial: DiaEspecial = new DiaEspecial();
        const fechaEspecial: string[] = data.dtfecha.toLocaleDateString().split('/');
        dEspecial.fecha = fechaEspecial[2] + '-' + fechaEspecial[1] + '-' + fechaEspecial[0];
        dEspecial.nombre = data.txtMotivo;
        if (data.cboTipoDia === 'true') {
          dEspecial.tipo = true;
        } else {
          dEspecial.tipo = false;
        }
        dEspecial.empresa = 1;

        if (this.modificar) {
          dEspecial.id = this.registroSeleccionado['id'];
          this.sdds.updateSpecialDays(dEspecial).subscribe(res => {
            if (res) {
              this.closeForm(true);
            }
          });
        } else {
          this.sdds.addSpecialDays(dEspecial).subscribe(res => {
            if (res) {
              this.closeForm(true);
            }
          });
        }

        break;
      default:
        break;
    }
  }

  /**
   * Elimina el registro seleccionado de la tabla
   *
   * @private
   * @memberof SpecialDaysComponent
   */
  private delete() {
    const idregistro = this.registroSeleccionado['id'];

    switch (this.tab) {
      case 'holidays':
        const dFestivo: DiaFestivo = new DiaFestivo();
        dFestivo.id = idregistro;
        this.sdds.deleteHolidays(dFestivo).subscribe(res => {
          if (res) {
            this.closeForm(true);
          } else {
            this.toastr.error('No se pudo eliminar el dia feriado');
          }
        });
        break;
      case 'special-days':
        const dEspecial: DiaEspecial = new DiaEspecial();
        dEspecial.id = idregistro;
        this.sdds.deleteEspecialDays(dEspecial).subscribe(res => {
          if (res) {
            this.closeForm(true);
          } else {
            this.toastr.error('No se pudo eliminar el dia especial');
          }
        });
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/special-days/special-days.component.ts